import React from 'react';
import { Calculator } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';

const ComptabiliteAlertsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.comptabilite.pages.comptabiliteAlertsPage.${key}`, opts);

  const alerts = [
    {
      id: 1,
      type: 'error',
      priority: 'critical',
      title: p('alert_unbalanced_title'),
      message: p('alert_unbalanced_message'),
      date: new Date().toISOString().split('T')[0],
      read: false,
    },
    {
      id: 2,
      type: 'warning',
      priority: 'high',
      title: p('alert_closing_title'),
      message: p('alert_closing_message'),
      date: new Date().toISOString().split('T')[0],
      read: false,
    },
    {
      id: 3,
      type: 'info',
      priority: 'medium',
      title: p('alert_tax_title'),
      message: p('alert_tax_message'),
      date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
      read: true,
    },
  ];

  return <ModuleAlertsPage moduleName={p('module_name')} moduleIcon={Calculator} alerts={alerts} />;
};

export default ComptabiliteAlertsPage;
